export default __webpack_public_path__ + "static/media/002.fb3ded9b.svg";